export const strings = {
  syncState: {
    idle: 'Up to date',
    syncing: 'Syncing...',
    error: 'Sync error',
    offline: 'Offline',
    unknown: 'Unknown'
  },
  labels: {
    status: 'Status',
    lastSync: 'Last sync'
  },
  actions: {
    download: 'Download',
    copyPath: 'Copy path'
  }
};
